import WsService from "../WsService";

export default class PaymentOptionsService {

    static retrievePaymentOptions() {
        let params = {
            'platform': 'CUSTOMER_PORTAL'
        }
        return WsService.get('/outbound/payment/option', params, 200).then(
            response => {
                let paymentOptions = [];
                response.forEach((singlePaymentOption) => {
                    paymentOptions.push(singlePaymentOption);
                })
                return paymentOptions;
            },
            error => {
                return error;
            }
        );
    }
}